
import React, {useContext } from 'react'
import  LayoutContext  from '../../LayoutContext'
import  UserContext  from '../../../modules/User/UserContext'
import { appModule } from 'services/module'

export const SiderSystem = () =>{
  const { collapsed } = useContext(LayoutContext)
  const {setPermissions} = useContext(UserContext)
  let currentSystem = appModule.getCurrSystem();
  let systemList = appModule.getSystemList();

  const handleChangeSystem = async (systemCode: string) => {
    currentSystem.code !== systemCode && await setPermissions(systemCode);
  }
  
  const renderActive = () =>{
    if(collapsed) return  <React.Fragment/>

    return (<React.Fragment>
       <div className='app-menu-system-current-middle'>
          {currentSystem.name}
        </div>
        <div className='app-menu-system-current-right'>
          <img src="/extendicon/img/xuanzhuan.png" className="app-menu-system-img" />
        </div>
    </React.Fragment>)
  }

  return (
    <div className="app-menu-system">
      <div className="app-menu-system-current">
        <div className='app-menu-system-current-left'>
          {collapsed?<img src="/extendicon/img/xuanzhuan.png" className="app-menu-system-img" />:<React.Fragment/> }
          {/* <img src="/extendicon/img/xitong.png" /> */}
          
        </div>
        {renderActive()}
      </div>
      <ul>
        {systemList.map((system: SystemVo) => {
          return <li 
            onClick={() =>handleChangeSystem(system.code)} 
            key={system.code} 
            data-active={currentSystem.code=== system.code}
          >
          {system.name}
          </li>
        })}
      </ul>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/layouts/components/SiderMenu/SiderSystem.tsx